class PermissionsFormContainer {
  constructor($q, appErrorHandler, appSessionCapabilities, brands, users, permissions) {
    'ngInject';

    this.$q = $q;
    this.appErrorHandler = appErrorHandler;
    this.appSessionCapabilities = appSessionCapabilities;
    this.brands = brands;
    this.users = users;
    this.permissions = permissions;

    this.scopes = [];
    this.scopesList = [];
    this.rolesByScope = {};
    this.rolesList = [];
    this.rolesCache = {};
    this.permissionsList = [];
    this.emptyList = [];
    this.permissionsByBrand = {};
    this.sharedPermissions = [];

    this.mainRequestFlag = false;
    this.subRequestsFlags = {
      access: false,
      relation: false,
      roles: false,
      scope: false,
      role: false,
    };

    this.selections = {
      scope: {},
      role: {},
      permissions: [],
    };

    this.customRole = false;

    this.autocompletes = {
      brands: {
        text: '',
        list: null,
        results: [],
        lastSearch: '',
        filter: (results) => this._filterBrandsAutocompleteResults(results),
      },
      users: {
        text: '',
        list: null,
        results: [],
        lastSearch: '',
        filter: (results) => this._filterUsersAutocompleteResults(results),
      },
    };

    this.pillsVisibility = {
      brands: false,
      users: false,
    };


    this.togglePermissionsAll = true;
    this.isBrandAdmin = false;
  }
  $onInit() {
    this.isBrandAdmin = this.appSessionCapabilities.isBrandAdmin(false);
    if (this.canAddBrands) {
      this.autocompletes.brands.list = this.brands.newList();
      this.autocompletes.brands.list.itemsPerPage = 100;
    }

    if (this.canAddUsers) {
      this.autocompletes.users.list = this.users.newList();
      this.autocompletes.users.list.itemsPerPage = 100;
    }

    this._loadScopes()
    .then(() => this._loadSelectedBrandsPermissions())
    .then(() => this._loadSingleRelationPermissionsIfNeeded());
  }
  save() {
    let result;
    if (this.mainRequestFlag) {
      result = this.$q.reject(new Error('The permissions are already being saved'));
    } else {
      const allowed = [];
      const denied = [];
      this.permissionsList.forEach((permission) => {
        const selected = this.selections.permissions
        .find((item) => item.id === permission.id);

        if (selected) {
          allowed.push(permission.id);
        } else {
          denied.push(permission.id);
        }
      });

      const userIds = this.usersList.map((user) => user.id);
      const brandIds = this.brandsList.map((brand) => brand.id);

      this.mainRequestFlag = true;
      result = this.permissions.save(
        userIds,
        brandIds,
        allowed,
        denied,
        this.selections.scope.id,
      )
      .then(() => {
        this.onSave();
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error while saving the permissions');
      })
      .then(() => {
        this.mainRequestFlag = false;
      });
    }

    return result;
  }
  selectScope(scope) {
    if (scope.id !== this.selections.scope.id) {
      this.customRole = false;
      this.selections.scope = scope;
      this.selections.role = {};
      this._filterPermissionsForSelectedScope();
      this._updateToggleFlag();
      this._loadScopeRoles()
      .then(() => this._calculateSharedRoles())
      .then(() => this._loadSingleRelationRoleIfNeeded())
      .then(() => this._calculateSelectedRoleIfNeeded());
    }
  }
  selectRole(role) {
    if (role.id !== this.selections.role.id) {
      this.customRole = false;
      this.selections.role = role;
      this._applyRolePermissions(role.permissions);
    }
  }
  autocompleteSearch(name, text) {
    const autocomplete = this.autocompletes[name];
    if (text === '') {
      autocomplete.lastSearch = '';
      autocomplete.results = [];
    } else if (text !== autocomplete.lastSearch) {
      autocomplete.lastSearch = text;
      autocomplete.results = [];
      autocomplete.list.fetch(autocomplete.lastSearch, true)
      .then((results) => {
        autocomplete.results = autocomplete.filter(results);
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error while filling the autocomplete');
      });
    }
  }
  autocompleteSelect(name, selection) {
    const autocomplete = this.autocompletes[name];
    autocomplete.lastSearch = '';
    autocomplete.results = [];
    const isForBrands = name === 'brands';
    if (isForBrands) {
      this._brandAutocompleteSelect(selection);
    } else {
      this._userAutocompleteSelect(selection);
    }
  }
  pillsToggleVisibility(name) {
    this.pillsVisibility[name] = !this.pillsVisibility[name];
  }
  pillsRemoveSelection(name, selection) {
    const isForBrands = name === 'brands';
    const target = isForBrands ? this.brandsList : this.usersList;
    const method = isForBrands ? this.onBrandsChange : this.onUsersChange;
    const index = target.findIndex((item) => item.id === selection.id);
    if (index > -1) {
      target.splice(index, 1);
      if (isForBrands && this.isBrandAdmin) {
        delete this.permissionsByBrand[selection.id];
        this._calculateSharedScopes();
        this._calculateSelections();
      }

      method({ [name]: target });
    }
  }
  togglePermission(permission, isSelected) {
    this._useCustomRole();
    this.selections.role = {};
    if (isSelected) {
      const index = this.selections.permissions
      .findIndex((item) => item.id === permission.id);
      if (index > -1) {
        this.selections.permissions.splice(index, 1);
      }
    } else {
      this.selections.permissions.push(permission);
    }

    this._updateToggleFlag();
  }
  togglePermissionsList() {
    this._useCustomRole();
    const newSelectedPermissions = angular.copy(this.selections.permissions);
    this.permissionsList.forEach((permission) => {
      const index = newSelectedPermissions
      .findIndex((item) => item.id === permission.id);
      if (this.togglePermissionsAll && index < 0) {
        newSelectedPermissions.push(permission);
      } else if (!this.togglePermissionsAll && index > -1) {
        newSelectedPermissions.splice(index, 1);
      }
    });

    this.togglePermissionsAll = !this.togglePermissionsAll;
    this.selections.permissions = newSelectedPermissions;
  }
  _loadScopes() {
    let result;
    if (this.mainRequestFlag) {
      result = this.$q.reject(new Error('The products are already being requested'));
    } else {
      this.mainRequestFlag = true;
      result = this.permissions.scopesWithPermissions()
      .then((scopes) => {
        this.scopes = scopes;
        if (!this.isBrandAdmin) {
          this.scopesList = scopes;
        }
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error while loading the products');
      })
      .then(() => {
        this.mainRequestFlag = false;
      });
    }

    return result;
  }
  _filterPermissionsForSelectedScope() {
    if (this.isBrandAdmin) {
      this.permissionsList = this.selections.scope.permissions
      .filter((permission) => this.sharedPermissions.includes(permission.id));
    } else {
      this.permissionsList = this.selections.scope.permissions;
    }
  }
  _loadScopeRoles() {
    let result;
    if (!this.selections.scope.id) {
      result = this.$q.reject(new Error('A product needs to be selected first'));
    } else if (this.subRequestsFlags.roles) {
      result = this.$q.reject(new Error('The profiles are already being requested'));
    } else {
      const { scope } = this.selections;
      result = this.permissions.roles(this.selections.scope.id)
      .then(({ roles }) => {
        this.rolesByScope[scope.id] = roles;
      });
    }

    return result;
  }
  _useCustomRole() {
    this.customRole = true;
    this.selections.role = {};
  }
  _applyRolePermissions(permissions) {
    const newSelectedPermissions = angular.copy(this.selections.permissions);
    this.permissionsList.forEach((permission) => {
      const index = newSelectedPermissions.findIndex((item) => item.id === permission.id);
      if (index > -1) {
        newSelectedPermissions.splice(index, 1);
      }
    });

    permissions.forEach((permission) => {
      newSelectedPermissions.push(permission);
    });

    this.selections.permissions = newSelectedPermissions;
    this._updateToggleFlag();
  }
  _loadBrandPermissions(brandIds) {
    let result;
    if (!this.brandsList.length || !this.isBrandAdmin) {
      this._calculateSharedScopes();
      result = this.$q.resolve();
    } else if (this.subRequestsFlags.access) {
      result = this.$q.reject(new Error('The permissions are already being requested'));
    } else {
      this.subRequestsFlags.access = true;
      result = this.brands.permissions(brandIds)
      .then((brands) => {
        Object.keys(brands).forEach((brandId) => {
          this.permissionsByBrand[brandId] = brands[brandId];
        });
        this._calculateSharedScopes();
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error while loading the permissions');
      })
      .then(() => {
        this.subRequestsFlags.access = false;
      });
    }

    return result;
  }
  _calculateSharedPermissions() {
    const brandIds = Object.keys(this.permissionsByBrand);
    let sharedPermissions;
    if (brandIds.length) {
      const firstId = brandIds.shift();
      sharedPermissions = this.permissionsByBrand[firstId].map((permission) => permission.id);
      if (brandIds.length) {
        this.sharedPermissions = brandIds
        .reduce((shared, brandId) => (
          this.permissionsByBrand[brandId]
          .filter((permission) => shared.includes(permission.id))
          .map((permission) => permission.id)
        ), sharedPermissions);
      } else {
        this.sharedPermissions = sharedPermissions;
      }
    } else {
      this.sharedPermissions = [];
    }
  }
  _calculateSharedScopes() {
    this.scopesList = [];
    if (this.isBrandAdmin) {
      this._calculateSharedPermissions();
      this.scopesList = this.scopes
      .filter((scope) => (
        scope.permissions.some((permission) => this.sharedPermissions.includes(permission.id))
      ));
    } else {
      this.scopesList = this.scopes;
    }
  }
  _calculateSharedRoles() {
    this.rolesList = [];
    if (this.isBrandAdmin) {
      this.rolesList = this.rolesByScope[this.selections.scope.id]
      .filter((role) => (
        !role.permissions.some((permission) => !this.sharedPermissions.includes(permission.id))
      ));
    } else {
      this.rolesList = this.rolesByScope[this.selections.scope.id];
    }
  }
  _calculateSelections() {
    if (
      this.selections.scope.id &&
      !this.scopesList.find((scope) => scope.id === this.selections.scope.id)
    ) {
      this.selections.scope = {};
      this.permissionsList = [];
      this.selections.permissions = [];
    } else if (this.selections.scope.id) {
      this._calculateSharedRoles();
      this._filterPermissionsForSelectedScope();
      this.selections.permissions = this.selections.permissions.filter((permission) => (
        this.sharedPermissions.includes(permission.id)
      ));
    }

    if (
      (this.selections.role.id && !this.selections.scope.id) ||
      (
        this.selections.role.id &&
        this.selections.scope.id &&
        !this.rolesList.find((role) => role.id === this.selections.role.id)
      )
    ) {
      this.selections.role = {};
    }


    this._updateToggleFlag();
  }
  _loadSelectedBrandsPermissions() {
    return this.brandsList.length ?
      this._loadBrandPermissions(this.brandsList.map((brand) => brand.id)) :
      this.$q.resolve();
  }
  _loadSingleRelationPermissionsIfNeeded() {
    let result;
    if (!this._usingSingleRelation()) {
      result = this.$q.resolve();
    } else if (this.subRequestsFlags.relation) {
      result = this.$q.reject(new Error('The permissions are already being requested'));
    } else {
      this.subRequestsFlags.relation = true;
      const [user] = this.usersList;
      const [brand] = this.brandsList;
      result = this.users.permissionsForBrand(user.id, brand.id)
      .then((permissions) => {
        this.selections.permissions = permissions.allowed;
        this._updateToggleFlag();
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, '', true);
      })
      .then(() => {
        this.subRequestsFlags.relation = false;
      });
    }

    return result;
  }
  _loadSingleRelationRoleIfNeeded() {
    let result;
    if (!this._usingSingleRelation()) {
      result = this.$q.resolve();
    } else if (this.subRequestsFlags.role) {
      result = this.$q.reject(new Error('The permissions are already being requested'));
    } else {
      this.subRequestsFlags.role = true;
      const [user] = this.usersList;
      const [brand] = this.brandsList;
      const { scope } = this.selections;
      result = this.users.rolesForBrand(user.id, brand.id, scope.id)
      .then((roles) => {
        if (roles.length) {
          const [role] = roles;
          if (this.rolesList.find((item) => item.id === role.id)) {
            this.selections.role = role;
          }
        } else {
          const selectedIds = this.selections.permissions
          .map((permission) => permission.id);

          const atLeastOnePermission = this.permissionsList
          .find((permission) => selectedIds.includes(permission.id));

          if (atLeastOnePermission) {
            this.customRole = true;
          }
        }
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, '', true);
      })
      .then(() => {
        this.subRequestsFlags.role = false;
      });
    }

    return result;
  }
  _calculateSelectedRoleIfNeeded() {
    if (
      !this.selections.role.id &&
      this.selections.permissions.length &&
      this.selections.scope.id &&
      this.rolesByScope[this.selections.scope.id].length
    ) {
      const selectedIdsList = this.selections.permissions.map((permission) => permission.id);
      const idsList = this.permissionsList
      .filter((permission) => selectedIdsList.includes(permission.id))
      .map((permission) => permission.id);
      const selecteRole = this.rolesByScope[this.selections.scope.id]
      .find((role) => (
        role.permissions.length === idsList.length &&
        !role.permissions.some((permission) => !idsList.includes(permission.id))
      ));
      if (selecteRole) {
        this.selections.role = selecteRole;
      }
    }
  }
  _usingSingleRelation() {
    return this.usersList.length === 1 && this.brandsList.length === 1;
  }
  _updateToggleFlag() {
    const visiblePermissionsLength = this.permissionsList.length;
    if (visiblePermissionsLength) {
      const selectedPermissionsLength = this.selections.permissions
      .filter((permission) => this.permissionsList.find((item) => item.id === permission.id))
      .length;

      const halfDivider = 2;
      const half = Math.round(visiblePermissionsLength / halfDivider);

      this.togglePermissionsAll = selectedPermissionsLength < half;
    }
  }
  _filterBrandsAutocompleteResults(results) {
    const brandIds = this.brandsList.map((brand) => brand.id);
    return results.filter((result) => !brandIds.includes(result.id));
  }
  _filterUsersAutocompleteResults(results) {
    const userIds = this.usersList.map((user) => user.id);
    return results.filter((result) => !userIds.includes(result.id));
  }
  _userAutocompleteSelect(selection) {
    const alreadyIn = this.usersList.find((user) => user.id === selection.id);
    if (!alreadyIn) {
      this.usersList.push(selection);
      this.onUsersChange({ users: this.usersList });
    }
  }
  _brandAutocompleteSelect(selection) {
    const alreadyIn = this.brandsList.find((user) => user.id === selection.id);
    if (!alreadyIn) {
      this.brandsList.push(selection);
      if (this.isBrandAdmin) {
        this._loadBrandPermissions([selection.id])
        .then(() => {
          this._calculateSelections();
          this.onBrandsChange({ brands: this.brandsList });
        });
      } else {
        this.onBrandsChange({ brands: this.brandsList });
      }
    }
  }
}

export default {
  controller: PermissionsFormContainer,
  bindings: {
    onSave: '&',
    onCancel: '&',

    ownerLabel: '@',
    ownerCaption: '<',

    brandsList: '<',
    showBrands: '<',
    canAddBrands: '<',
    canRemoveAllBrands: '<',
    onBrandsChange: '&',

    usersList: '<',
    showUsers: '<',
    canAddUsers: '<',
    canRemoveAllUsers: '<',
    onUsersChange: '&',
  },
  template: `
    <permissions-form
      read-only="!$ctrl.canAddBrands && !$ctrl.canAddUsers"

      loading="$ctrl.mainRequestFlag"
      loading-list="$ctrl.subRequestsFlags.scope"

      owner-label="{{$ctrl.ownerLabel}}"
      owner-caption="$ctrl.ownerCaption"

      show-save="$ctrl.canAddBrands || $ctrl.canAddUsers"
      save-text="{{$ctrl.canRemoveAllBrands || $ctrl.canRemoveAllUsers ? 'Assign' : 'Update'}}"
      on-save="$ctrl.save()"
      disable-save="
        !$ctrl.selections.scope.id ||
        $ctrl.mainRequestFlag ||
        $ctrl.subRequestsFlags.scope ||
        $ctrl.subRequestsFlags.role
      "

      on-cancel="$ctrl.onCancel()"

      brands="$ctrl.brandsList"
      show-brands="$ctrl.showBrands"
      show-all-brands="$ctrl.pillsVisibility.brands"
      can-add-brands="$ctrl.canAddBrands"
      can-remove-all-brands="$ctrl.canRemoveAllBrands"
      autocomplete-brands-results="$ctrl.autocompletes.brands.results"

      users="$ctrl.usersList"
      show-users="$ctrl.showUsers"
      show-all-users="$ctrl.pillsVisibility.users"
      can-add-users="$ctrl.canAddUsers"
      can-remove-all-users="$ctrl.canRemoveAllUsers"
      autocomplete-users-results="$ctrl.autocompletes.users.results"

      scopes="$ctrl.scopesList"
      selected-scope="$ctrl.selections.scope"
      disable-scopes="
        !$ctrl.usersList.length ||
        !$ctrl.brandsList.length ||
        $ctrl.subRequestsFlags.access ||
        $ctrl.subRequestsFlags.roles
      "
      on-scope-selection="$ctrl.selectScope(scope)"

      roles="$ctrl.rolesList"
      selected-role="$ctrl.selections.role"
      disable-roles="
        !$ctrl.usersList.length ||
        !$ctrl.brandsList.length ||
        !$ctrl.rolesList.length ||
        !$ctrl.selections.scope.id ||
        $ctrl.subRequestsFlags.role ||
        $ctrl.subRequestsFlags.access
      "
      using-custom-role="$ctrl.customRole"
      on-role-selection="$ctrl.selectRole(role)"

      permissions="
        $ctrl.usersList.length && $ctrl.brandsList.length ?
          $ctrl.permissionsList :
          $ctrl.emptyList
      "
      selected-permissions="$ctrl.selections.permissions"
      toggle-permissions-all="$ctrl.togglePermissionsAll"
      on-permission-toggle="$ctrl.togglePermission(permission, isSelected)"
      on-permissions-list-toggle="$ctrl.togglePermissionsList()"

      on-autocomplete-search="$ctrl.autocompleteSearch(name, text)"
      on-autocomplete-selection="$ctrl.autocompleteSelect(name, selection)"

      on-toggle-pills-visibility="$ctrl.pillsToggleVisibility(name)"
      on-remove-pill="$ctrl.pillsRemoveSelection(name, selection)"
    ></permissions-form>
  `,
};
